module.exports = __webpack_public_path__ + "static/media/file-line.104fe7e2.svg";